module.exports = __webpack_public_path__ + "img/monster.01cbd837.svg";